var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M131.1,36l5.1-25.7H108l5.1,25.7H131.1z M133,13l-4.1,20.3h-13.5l-4-20.3H133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,51.4c2.8,0,5.1-2.3,5.1-5.1c0-2.8-2.3-5.1-5.1-5.1l-77.6,0l-13-13c-2-2-5.3-2-7.3,0s-2,5.3,0,7.3L33,49.9 c1,1,2.3,1.5,3.6,1.5h20.6v25.7h23.1V51.4H116.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.9,
    cy: 28.3,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7,28.3c2.3,0,4.6-0.9,6.4-2.6c3.5-3.5,3.5-9.2,0-12.7c-1.8-1.8-4.1-2.6-6.4-2.6s-4.6,0.9-6.4,2.6 c-3.5,3.5-3.5,9.2,0,12.7C30.1,27.4,32.4,28.3,34.7,28.3z M30.3,14.8c1.2-1.2,2.8-1.8,4.4-1.8c1.7,0,3.3,0.6,4.4,1.8 c1.2,1.2,1.8,2.8,1.8,4.4s-0.6,3.3-1.8,4.4c-1.2,1.2-2.8,1.8-4.4,1.8c-1.7,0-3.3-0.6-4.4-1.8c-1.2-1.2-1.8-2.8-1.8-4.4 S29.1,16,30.3,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,82.3l-45.2,45.2c-0.9,0.9-1.5,2.2-1.5,3.6c0,2.8,2.3,5.1,5.1,5.1c1.4,0,2.7-0.6,3.6-1.5l21.4-21.4h34.7 c2.8,0,5.1-2.3,5.1-5.1V82.3H57z M70.1,83.8v19.3H50.8L70.1,83.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.67a33dacc71c27b268858e57339d2803.svg";
export { ForwardRef as ReactComponent };